// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"139":"metadata-sidebar","206":"skills-sidebar","277":"content-sidebar","551":"activity-sidebar","668":"content-open-with","716":"details-sidebar","751":"versions-sidebar"}[chunkId] || chunkId) + ".bundle.js";
};